import { render, staticRenderFns } from "./shicifetch.vue?vue&type=template&id=e8eedec4&scoped=true"
import script from "./shicifetch.vue?vue&type=script&lang=js"
export * from "./shicifetch.vue?vue&type=script&lang=js"
import style0 from "./shicifetch.vue?vue&type=style&index=0&id=e8eedec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eedec4",
  null
  
)

export default component.exports